<script setup lang="ts">
import {Calendar, Leaf} from "lucide-vue-next";
import "@/assets/styles/home.css";

import {onMounted} from "vue";

import AboutView from "@/views/AboutView.vue";
import ReferencesView from "@/views/ReferencesView.vue";
import ReviewView from "@/views/ReviewView.vue";
import ServiceView from "@/views/ServiceView.vue";
import ContactView from "@/views/ContactView.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";
import SidebarComponent from "@/components/SidebarComponent.vue";

onMounted(() => {
  const elements = document.querySelectorAll(".animate");

  const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      {threshold: 0.2}
  );

  elements.forEach((el) => observer.observe(el));
});
</script>

<template>

  <div class="home" id="home">

    <section class="hero">

      <div class="hero-overlay">

        <div class="hero-content animate">

          <div class="hero-badge">
            Gartenpflege • Pflasterarbeiten • Sichtschutz
          </div>

          <h1>
            Garten- & Landschaftsbau<br/>
            mit Leidenschaft
          </h1>

          <p>
            Wir gestalten moderne Außenanlagen, pflegen Grünflächen
            und schaffen individuelle Wohlfühloasen rund um Ihr Zuhause.
          </p>

          <div class="hero-buttons">

            <a href="#contact" class="appointment-button">
              <Calendar/>
              Projekt anfragen
            </a>

            <a href="#pakete" class="call-button">
              <Leaf/>
              Leistungen ansehen
            </a>

          </div>

        </div>

      </div>

    </section>
    <!-- SECTIONS -->
    <SidebarComponent/>
    <section id="about">
      <AboutView/>
    </section>

    <section id="pakete">
      <ServiceView/>
    </section>

    <section id="review">
      <ReviewView/>
    </section>

    <section id="references">
      <ReferencesView/>
    </section>

    <section id="contact">
      <ContactView/>
    </section>

    <FooterImpressum/>

  </div>
</template>

<style scoped>
</style>